import AppNumberrangesIndex from "./numberRange.vue";
import AppNumberrangesList from "./list/list.vue";
import AppNumberrangesItem from "./item/item.vue";

const routes = [
  {
    path: "/numberRange",
    component: AppNumberrangesIndex,
    meta: {
      auth: {
        roles: "numberRange.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "numberRange.index",
        component: AppNumberrangesList,
        meta: {
          auth: {
            roles: "numberRange.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "numberRange.create",
        component: AppNumberrangesItem,
        meta: {
          auth: {
            roles: "numberRange.create",
            redirect: { name: "numberRange.index" }
          }
        }
      },
      {
        path: ":id",
        name: "numberRange.edit",
        component: AppNumberrangesItem,
        meta: {
          auth: {
            roles: "numberRange.update",
            redirect: { name: "numberRange.index" }
          }
        }
      }
    ]
  }
];

export default routes;
